export const OPTIONS = "OPTIONS";
export const LOAD_GAMES = "LOAD";
export const LOCALIZATION = "LOCALIZATION";
export const CREDITS = "CREDITS";
export const HELP = "HELP";
export const PLAY = "PLAY";
export const MULTIPLAYER_SERVER_CHOOSER = "MULTIPLAYER_SERVER_CHOOSER";
export const LANGUAGE = "LANGUAGE";
export const TODO = "TODO";